var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3H18V9C18 12.3137 15.3137 15 12 15C8.68629 15 6 12.3137 6 9V3ZM8 5V9C8 11.2091 9.79086 13 12 13C14.2091 13 16 11.2091 16 9V5H8Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H4.5C3.11929 5 2 6.11929 2 7.5C2 9.98528 4.01472 12 6.5 12H7V10H6.5C5.11929 10 4 8.88071 4 7.5C4 7.22386 4.22386 7 4.5 7H6V5Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H19.5C20.8807 5 22 6.11929 22 7.5C22 9.98528 19.9853 12 17.5 12H17V10H17.5C18.8807 10 20 8.88071 20 7.5C20 7.22386 19.7761 7 19.5 7H18V5Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5H13V18H11V14.5Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 18.4477 7.44772 18 8 18H16C16.5523 18 17 18.4477 17 19V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V19Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.4f2d94feb6fa74cb9096e93ac1a9e6ff.svg";
export { ForwardRef as ReactComponent };